export default __webpack_public_path__ + "static/media/gallery_06.5598a64d.jpg";